import { useEffect, useState } from 'react';

import { EVENT } from '../../analytics/analyticsConsts';
import { useImpState } from '../../app/hooks';
import { ANALYTICS } from '../../firebase/firebase';
import Button from '../button/Button';
import DynamicQRCode from '../dynamicQRCode/dynamicQRCode';
import Spinner from '../spinner/Spinner';
import styles from './Modal.module.css';

interface ModalProps {
  headerImg?: string;
  header: string;
  body1: string;
  body2?: string;
  body3?: string;
  showQR?: boolean;
  qrMessage?: string;
  qr?: string;
  hideMobileBodyBtn?: boolean;
  hideMobileBtn1?: boolean;
  hideMobileBtn2?: boolean;
  address?: string[];
  buttonName1?: string;
  buttonName2?: string;
  bodyButtonName?: string;
  button1Click?: any;
  button2Click?: any;
  bodyButtonClick?: any;
  pillBtn1?: boolean;
  pillBtn2?: boolean;
  includeSupportEmail?: boolean;
  pillBodyButton?: boolean;
  link?: boolean;
  linkText?: string;
  linkClick?: any;
  delay?: number;
  analyticsEvent?: EVENT;
}

export default function Modal({
  headerImg,
  header,
  body1,
  body2,
  body3,
  showQR,
  qrMessage,
  qr,
  hideMobileBodyBtn,
  hideMobileBtn1,
  hideMobileBtn2,
  address,
  bodyButtonName,
  bodyButtonClick,
  pillBodyButton,
  buttonName1,
  buttonName2,
  button1Click,
  button2Click,
  pillBtn1,
  pillBtn2,
  includeSupportEmail,
  link,
  linkText,
  linkClick,
  delay,
  analyticsEvent,
}: ModalProps) {
  const [delay_finished, set_delay_finished] = useState(false);

  useEffect(() => {
    if (analyticsEvent) {
      ANALYTICS.logEvent(analyticsEvent);
    }
    if (delay) {
      (async () => {
        await new Promise((f) => setTimeout(f, delay));
        set_delay_finished(true);
        ANALYTICS.logEvent(EVENT.APP_ASYNC_APPLICATION_PROCESSING_VIEWED);
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { appScreenState } = useImpState();

  return (
    <div>
      {delay && !delay_finished ? (
        <div className={styles.container}>
          <div className={styles.centerContent}>
            <Spinner />
          </div>
        </div>
      ) : (
        <div className={styles.container}>
          <div className={styles.centerContent}>
            {headerImg && (
              <img className={styles.headerImg} src={headerImg} alt="card" />
            )}
            <p className={headerImg ? styles.headerWithImg : styles.header}>
              {header}
            </p>
            <p className={styles.body}>
              {body1}{' '}
              {includeSupportEmail ? (
                <span>
                  <a href={'mailto:support@imprint.co'}>support@imprint.co</a>.
                </span>
              ) : (
                ''
              )}
            </p>
            {address && (
              <p className={styles.address}>
                {address[0]}
                {address[1] !== ' ' && (
                  <>
                    <br /> {address[1]}
                  </>
                )}
                <br />
                {address[2]}
              </p>
            )}
            {body2 ? <p className={styles.body}>{body2}</p> : ''}
            {body3 ? <p className={styles.body}>{body3}</p> : ''}
            {showQR && (
              <div className={styles.qrCode}>
                <DynamicQRCode width="80" height="80" image={qr || ''} />
              </div>
            )}
            {qrMessage ? <p className={styles.qrMessage}>{qrMessage}</p> : ''}
            {link && (
              <button className={styles.link} onClick={() => linkClick()}>
                {linkText}
              </button>
            )}
            {bodyButtonName && (
              <div className={styles.bodyButton}>
                <Button
                  value={bodyButtonName}
                  hideOnMobile={hideMobileBodyBtn}
                  pill={pillBodyButton ? true : false}
                  handleClick={() => bodyButtonClick()}
                  loading={appScreenState.loading}
                />
              </div>
            )}
          </div>
          <div className={styles.bottomButtons}>
            {buttonName1 ? (
              <Button
                value={buttonName1}
                hideOnMobile={hideMobileBtn1}
                pill={pillBtn1 ? true : false}
                handleClick={() => button1Click()}
                loading={appScreenState.loading}
              />
            ) : (
              ''
            )}
            {buttonName2 ? (
              <Button
                value={buttonName2}
                hideOnMobile={hideMobileBtn2}
                pill={pillBtn2 ? true : false}
                handleClick={() => button2Click()}
                loading={appScreenState.loading}
              />
            ) : (
              ''
            )}
          </div>
        </div>
      )}
    </div>
  );
}
